import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
} from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useAddOptionMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) => api.post(API_ROUTES.ADD_COMMUNITY_TRIGGER_OPTION, data),
      onSuccess: () => {},
      onError: (error) => {
        showToast("error", error.response.data.message);
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_COMMUNITY_TRIGGER_OPTIONS);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useGetOptionQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_COMMUNITY_TRIGGER_OPTIONS],
    queryFn: () => api.get(API_ROUTES.GET_COMMUNITY_TRIGGER_OPTIONS),
  });

  return { data: data?.data?.data ?? [], isPending, isError, error };
};

export const useDeleteOptionMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (id) => api.delete(`${API_ROUTES.DELETE_COMMUNITY_TRIGGER_OPTION}/${id}`),
      onSuccess: () => {},
      onError: (error) => {
        showToast("error", error.response.data.message);
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_COMMUNITY_TRIGGER_OPTIONS);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};

export const useUpdateOptionMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isError, error, isLoading, isSuccess, isPending } =
    useMutation({
      mutationFn: (data) =>
        api.put(`${API_ROUTES.UPDATE_COMMUNITY_TRIGGER_OPTION}/${data.id}`, data),
      onSuccess: () => {},
      onError: (error) => {
        showToast("error", error.response.data.message);
      },
      onSettled: () => {
        queryClient.invalidateQueries(API_ROUTES.GET_COMMUNITY_TRIGGER_OPTIONS);
      },
    });
  return { mutate, isError, error, isLoading, isSuccess, isPending };
};
